import { Outlet } from "react-router";

export default function BlankLayout() {

    return (
        <div className="monitering">
            <Outlet/>
        </div>
    );
}
